import {
    Service
} from '../service.js';
import {
    env
} from '../env.js';

class EmpresasService extends Service {
    DATA_DE_SAIDA_PADRAO = '1970-01-01T00:00'
    
    constructor() {
        super();
    }

    listarEmpresas(filtroPersonalizado) {
        let filtro = {
            'page[limit]': 200,
            'page[offset]': 0,
            'filter[ativa]': true,
            'filter[utilizaEtarefasWeb]': true
        }
        if(filtroPersonalizado) {
            filtro = {
                ...filtro,
                ...filtroPersonalizado
            }
        }
        const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(filtro);
        const url =
            `${env.baseIdentificacao}empresas${queryString}`;
        /**
         * @TODO Na próxima tarefa onde tivermos teste em escopo global de empresas
         * verificar a possibilidade do listar trazer o objeto completo, e se necessário
         * fazer a "composição" com a conversão de objeto em um utils para dividir
         * a responsabilidade.
         * 
         * Tentar padronizar para os services sempre retornarem o objeto que o back trás
         * para evitar necessidade de diversos métodos/services diferentes pro mesmo
         * endpoint.
         */
        return super.buscarEconverterObjeto(url, 'empresas');
    }


    listarEmpresasObjetoCompleto(filtro) {
        let url = `${env.baseIdentificacao}empresas`

        let filtroInterno = {
            "page[limit]": 200,
            "page[offset]": 0,
            "filter[ativa]": true,
            "filter[dataSaidaEscritorio]": "1970-01-01T00:00"
        }
        
        if(filtro) {
            filtroInterno = filtro;
        }
        /**
         * @TODO No próximo momento que for necessário modificação deste método lembrar
         * de trocar a chamada para converterObjetoDeFiltrosParaURIEncodedString;
         * O método converterObjetoDeFiltrosParaQueryString está depreciado devido a falha
         * de conversão de alguns caracteres que gerava erro no back
         */

        const queryString = super.converterObjetoDeFiltrosParaQueryString(filtroInterno);
        return this.paginarEmpresas(`${url}${queryString}`);
    }

    async getById(id) {
        let url = `${env.baseIdentificacao}/empresas/${id}`;
        return await this.get(url);
    }

    async paginarEmpresas(url) {
        let empresas = []

        do {
            const response = await this.get(url);
            empresas = empresas.concat(response.data);
            url = response.links.next
        } while (url !== null);

        return empresas;
    }

    async listarSemLegalizacao() {
        let url = `${env.baseIdentificacao}/empresas`;

        let filtroInterno = {
            "page[limit]": 200,
            "page[offset]": 0,
            "filter[ativa]": true,
            "filter[utilizaEtarefasWeb]": true,
            "filter[legalizacaoEmAndamento]": false,
            "filter[dataSaidaEscritorio]": "1970-01-01T00:00"
        }

        const queryString = super.converterObjetoDeFiltrosParaURIEncodedString(filtroInterno);
        return await this.paginarEmpresas(`${url}${queryString}`);
    }
}

export const empresasService = new EmpresasService()